/** Error codes returned by the API ({ error: { code, message? } }). The client translates codes. */
export const ERROR_CODES = [
  'bad_request',
  'validation',
  'unauthorized',
  'forbidden',
  'not_found',
  'conflict',
  'gone',
  'too_many_requests',
  'unsupported_media_type',
  'payload_too_large',
  'quota_exceeded',
  'invalid_credentials',
  'token_invalid',
  'host_not_allowed',
  'csrf',
  'last_admin',
  'internal',
] as const;
export type ErrorCode = (typeof ERROR_CODES)[number];

export interface ApiErrorBody {
  error: { code: ErrorCode; message?: string; details?: unknown };
}
